module.exports = __webpack_public_path__ + "img/notification_success.cd68c62f.svg";